import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding } from '@angular/core';

import { Store } from '@ngrx/store';
import { Decimal } from 'decimal.js';

import { IBetslipRootState } from '../../../../../base/store/state';
import { BetslipSummaryService } from '../../../../summary/services/betslip-summary.service';
import { ITaxationInfoViewModel } from '../../../../taxation/components/digital/taxation-info.component';
import { OverAskMessagesProvider } from '../../../services/over-ask-messages.provider';
import { BetslipOverAskSummaryBaseComponent } from '../../betslip-overask-summary-base.component';

@Component({
    selector: 'bs-digital-over-ask-summary',
    templateUrl: './betslip-over-ask-summary.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./betslip-over-ask-summary.component.scss'],
    standalone: false,
})
export class BetslipOveraskSummaryComponent extends BetslipOverAskSummaryBaseComponent {
    @HostBinding('class.betslip-over-ask-summary') hostCssClass = true;
    @HostBinding('class.betslip-over-ask-summary--has-stake-change')
    get hasStakeChangeClass(): boolean {
        return this.hasStakeChange;
    }

    get shouldShowChanges(): boolean {
        return this.hasChange && !this.isSingleBet;
    }

    isInfoVisible = false;

    messages = {
        stakeLabel: this.overAskMessagesProvider.messages.stake,
        cancelButtonTitle: this.overAskMessagesProvider.messages.cancel,
        maxReturnLabel: this.overAskMessagesProvider.messages.possibleWinnings,
        netMaxReturnLabel: this.overAskMessagesProvider.messages.possibleWinningsNet,
        newStake: this.overAskMessagesProvider.messages.newStake,
        newOdds: this.overAskMessagesProvider.messages.newOdds,
        totalOddsLabel: this.overAskMessagesProvider.messages.totalOdds,
        totalStakeLabel: this.overAskMessagesProvider.messages.totalStake,
        eachWayAbbr: this.overAskMessagesProvider.messages.eachWayAbbr,
        winMarketAbbr: this.overAskMessagesProvider.messages.winMarketAbbr,
    };

    constructor(
        changeRef: ChangeDetectorRef,
        betslipSummaryService: BetslipSummaryService,
        store: Store<IBetslipRootState>,
        private overAskMessagesProvider: OverAskMessagesProvider,
    ) {
        super(changeRef, betslipSummaryService, store);
    }

    provideTaxationViewModel(): ITaxationInfoViewModel {
        const possibleWinnings = this.vm.offer.maxReturn ? new Decimal(this.vm.offer.maxReturn) : null;
        const taxationAmount = new Decimal(this.vm.offer.taxAmount);
        const possibleWinningsNet = possibleWinnings ? possibleWinnings.minus(taxationAmount) : null;

        return <ITaxationInfoViewModel>{
            possibleWinningsGross: possibleWinnings,
            possibleWinningsNet,
            taxationTitle: this.overAskMessagesProvider.messages.tax,
            taxationAmount,
            taxationRate: this.vm.offer.taxRate ? new Decimal(this.vm.offer.taxRate) : null,
        };
    }

    winsInfoClick(): void {
        this.isInfoVisible = this.hasTax;
        this.changeRef.markForCheck();
    }
}
